/**
 * Landing placeholder routes — EN copy.
 *
 * Covers the safe placeholder destinations of the landing CTAs (/register
 * and /plans). The real auth + pricing surfaces land in their own branches;
 * these strings render the temporary placeholder until then.
 *
 * Authority:
 *   DEC-048, DEC-049, DEC-050, PO-supplied placeholder copy.
 */

export const landingPlaceholdersEn = {
  'landing.placeholders.register.title': 'Registration is coming soon',
  'landing.placeholders.register.body':
    'Workerize registration will open once account setup is connected.',
  'landing.placeholders.plans.title': 'Plans are coming soon',
  'landing.placeholders.plans.body':
    'Workerize plans will be published once subscription setup is ready.',
} as const;

export type LandingPlaceholdersEn = typeof landingPlaceholdersEn;
